import { render, staticRenderFns } from "./Carrers.vue?vue&type=template&id=c2a989fa&scoped=true"
import script from "./Carrers.vue?vue&type=script&lang=js"
export * from "./Carrers.vue?vue&type=script&lang=js"
import style0 from "./Carrers.vue?vue&type=style&index=0&id=c2a989fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a989fa",
  null
  
)

export default component.exports